module.exports = __webpack_public_path__ + "static/media/homeActive.1f97225c.svg";